import React from 'react'
import './Copyrightpolicy.css'

const ContentReviewPolicy = () => {
    return (
   <div>
            <div id="heading">
                <h3>Content Review Policy</h3>
            </div>
            <div class="conntent-conntainer">
                    
                </div>
            </div>
     
      

    )
}

export default ContentReviewPolicy
